export default "__VITE_PUBLIC_ASSET__eb0a095b__"